import { useParams } from 'react-router-dom'
import { ClientRouter } from '../Client'

export const CompanyClientsRoute = () => {
  const { company } = useParams()

  return <ClientRouter query={{ company }} />
}